import { useI18n } from "../lib/i18n";

// Iter 196 — Spanish (es) added as a third supported locale alongside en/de.
// Neutral pan-LatAm register, formal "usted", locked lexicon for Credits /
// Platform Account / Case Reconciliation / Credit Release. Legal pages
// (Impressum, Privacy, Terms) intentionally remain EN/DE-only.
export default function LanguageSwitcher() {
  const { locale, setLocale } = useI18n();
  return (
    <div className="inline-flex items-center border border-white/15 font-mono text-xs" data-testid="language-switcher">
      {["en", "de", "es"].map((l) => (
        <button
          key={l}
          data-testid={`lang-${l}`}
          onClick={() => setLocale(l)}
          className={`px-2.5 py-1 uppercase transition-colors ${locale === l ? "bg-[#2DD4A7] text-[#04150F]" : "text-[#E8ECF4] hover:bg-white/10"}`}
        >
          {l}
        </button>
      ))}
    </div>
  );
}
